import { render } from "./DeploymentView.vue?vue&type=template&id=85d4dd0c"
import script from "./DeploymentView.vue?vue&type=script&lang=js"
export * from "./DeploymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__